import { Path } from '@/main/router/routerPath';
import { WmsAdmin } from './wmsAdmin';
import { WmsReception } from './wmsReception';
import { WmsParking } from './wmsParking';
import { WmsDashboard } from './wmsDashboard';
import { WmsServiceAdvisor } from './wmsServiceAdvisor';
import { WmsJobController } from './wmsJobController';
import { WmsTechnician } from './wmsTechnician';
import { WmsFinalInspection } from './wmsFinalInspector';
import { WmsWashingLabor } from './wmsWashingLabor';
import { WmsVasSupervisor } from './WmsVasSupervisor';
import { WmsSecurityguard } from './wmsSecurityguard';

export const router = new Path('wmsModule').addChildren([
    WmsDashboard.router,
    WmsReception.router,
    WmsParking.router,
    WmsAdmin.router,
    WmsServiceAdvisor.router,
    WmsJobController.router,
    WmsTechnician.router,
    WmsFinalInspection.router,
    WmsWashingLabor.router,
    WmsVasSupervisor.router,
    WmsSecurityguard.router
]);
